module.exports = __webpack_public_path__ + "static/anne-pitman-logo-horizontal-pink-e0e66ee7a36d11b8d3023bdd097179ff.svg";